module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-7-m3.708178c8.jpg";